module.exports = __webpack_public_path__ + "static/media/edward.6f41c289.png";